// extracted by mini-css-extract-plugin
module.exports = {"tabpanel":"Tab_tabpanel__PxukY","page-editing":"Tab_page-editing__s_S8o"};